/**
 * ProductShowMoreBtn custom element
 * 
 * Controls the "Show More Images" button on the product page.
 * When clicked, reveals additional hidden product media items.
 * Hides itself after being clicked.
 * 
 * @class ProductShowMoreBtn
 * @extends {HTMLElement}
 * @method showMoreImages Reveals hidden product media items.
 * @method connectedCallback Adds click handler to show images and hide button.
 */

class ProductShowMoreBtn extends HTMLElement {
  constructor() {
    super();
    this.defaultHiddenProdMedia = document.querySelectorAll('.js-product__media-item.product__media-item--hidden');
    this.hiddenItemsAreShown = false;
  }

  showMoreImages() {
    this.hiddenItemsAreShown = true;
    this.defaultHiddenProdMedia.forEach(item => {
      item.classList.remove('product__media-item--hidden');
    });
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      if (!this.hiddenItemsAreShown) {
        this.showMoreImages();
        this.classList.add('hidden'); // Hide the button after it's clicked
      }
    });
  }
}

customElements.define('product-show-more-btn', ProductShowMoreBtn);